import { observable, makeObservable, action } from 'mobx';
import { isBusinessNeedVerify, handleRealDetail, getRealFlag, getInstallAppList, handleRealPrompt } from '@/api/FaceAndRealName';
import Toast from '@/components/Toast';

class Face {
    constructor() {
        makeObservable(this);
    }
    @observable faceIsInstall = false;
    @observable realIsInstall = false;
    @observable state = {
        realEnable: 1,
        faceIsInstall: false,
        realIsInstall: false,
        realNameDetail: {
            verify_state: 0, //0未认证 1已认证
            verify_name: '',
            verify_no: '',
            verify_time: ''
        }
    };
    @action setState = (data) => {
        this.state = Object.assign({}, this.state, data);
    };
    //获取实名详情
    handleRealNameDetail = async () => {
        let res = await handleRealDetail();
        if (res.code === '00000') {
            this.setState({ realNameDetail: res.data });
        }
        return false;
    };
    //获取业务是否开启实名或者人脸
    //后端已经判断管理端开关是否开启关闭--考试会返回人脸是否开启
    getBusinessVerify = async (data) => {
        let res = await isBusinessNeedVerify(data);
        if (res.code === '00000') {
            return res.data;
        }
        return false;
    };
    // 业务中是否需要实名---后端已经判断管理端开关是否开启关闭
    isNeedRealName = async (data) => {
        let isNeedVerify = false,
            flag = await this.getBusinessVerify(data);

        //业务开启了实名
        if (flag) {
            //判断是否已经实名
            let stateRes = await handleRealDetail();
            if (stateRes.code === '00000' && stateRes.data.verify_state !== 1) {
                console.log('未完成实名');
                isNeedVerify = true;
            }
        }
        return isNeedVerify;
    };
    //是否开启了人脸
    isNeedFace = async (data) => {
        // 0 -未开启人脸 1-开启人脸 2-未完成实名
        let result = 0,
            flag = await this.getBusinessVerify(data);
        //业务开启了实名或者人脸
        if (flag) {
            result = 1;
            //判断是否已经实名
            let stateRes = await handleRealDetail();
            if (stateRes.code === '00000' && stateRes.data.verify_state !== 1) {
                result = 2;
            }
        }
        return result;
    };
    //获取实名认证状态---和业务无关
    getRealNameInfo = async () => {
        // let isInstall = await this.isInstallRealApp();
        // if (!isInstall) {
        //     return false;
        // }
        let flagRes = await getRealFlag(); //管理端是否开启
        if (flagRes.code !== '00000') {
            return false;
        }
        this.setState({
            realEnable: flagRes.data.enable
        });
        if (flagRes.data.enable === 1) {
            await this.handleRealNameDetail();
        }
    };
    //获取已安装的应用列表
    getInstallAppList = async () => {
        let res = await getInstallAppList();
        if (res && res.data) {
            return res.data;
        }
        return [];
    };
    //是否安装了实名应用
    isInstallRealApp = async (appList) => {
        let installList = appList || (await this.getInstallAppList()),
            index = installList.findIndex((ele) => ele.application_id === '1864592579040006144');
        this.setState({
            realIsInstall: index !== 1
        });

        if (index !== -1) {
            return true;
        }
        return false;
    };
    //是否安装了人脸识别应用
    isInstallFaceApp = async (appList) => {
        let installList = appList || (await this.getInstallAppList()),
            index = installList.findIndex((ele) => ele.application_id === '1864593145157799936');
        this.setState({
            faceIsInstall: index !== 1
        });

        if (index !== -1) {
            return true;
        }
        return false;
    };

    @observable promptboxData = [];
    @action setPromptboxData = (data) => {
        this.promptboxData = data || [];
    };

    //获取项目弹窗整合状态
    //function_type 1实名认证 2完善信息 3通知公告 4问卷调查
    //function_status 0没有此功能 1有功能未提交 2有功能已提交
    //params
    getRealPrompt = async (param) => {
        const { code, msg, data } = await handleRealPrompt(param);
        if (code === '00000') {
            this.setPromptboxData(data);
            let hasUnsubmit = false;
            for (let index = 0; index < data.length; index++) {
                if (data[index].function_status === 1) {
                    this.setCurrentPromptbox(data[index]);
                    hasUnsubmit = true;
                    break;
                }
            }
            if (!hasUnsubmit) {
                this.setCurrentPromptbox({});
            }
        } else {
            this.setPromptboxData([]);
            this.setCurrentPromptbox({});
            Toast.error(msg);
        }
    };

    @observable currentPromptbox = {};

    @action
    setCurrentPromptbox = (data) => {
        const preCurrentPromptbox = this.currentPromptbox;
        if (Object.keys(preCurrentPromptbox).length && Object.keys(data).length === 0) {
            window.location.reload();
        } else {
            this.currentPromptbox = { ...data };
        }
    };
}
export default new Face();
